"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentBucket = void 0;
var ShipmentBucket;
(function (ShipmentBucket) {
    ShipmentBucket["DirectAll"] = "directAll";
    ShipmentBucket["DirectOnSchedule"] = "directOnSchedule";
    ShipmentBucket["DirectAtRisk"] = "directAtRisk";
    ShipmentBucket["DirectDelayed"] = "directDelayed";
    ShipmentBucket["DirectPendingFrtReschedule"] = "directPendingFrtReschedule";
    ShipmentBucket["DirectAbandoned"] = "directAbandoned";
    ShipmentBucket["DirectIssues"] = "directIssues";
    ShipmentBucket["DirectClaims"] = "directClaims";
    ShipmentBucket["IntegratedAll"] = "integratedAll";
    ShipmentBucket["IntegratedIntercepted"] = "integratedIntercepted";
    ShipmentBucket["IntegratedDelayed"] = "integratedDelayed";
    ShipmentBucket["IntegratedAbandoned"] = "integratedAbandoned";
    ShipmentBucket["IntegratedIssues"] = "integratedIssues";
    ShipmentBucket["IntegratedClaims"] = "integratedClaims";
    ShipmentBucket["ScheduledAll"] = "scheduledAll";
    ShipmentBucket["ScheduledPending"] = "scheduledPending";
    ShipmentBucket["ScheduledConfirmed"] = "scheduledConfirmed";
    ShipmentBucket["ScheduledExpired"] = "scheduledExpired";
})(ShipmentBucket = exports.ShipmentBucket || (exports.ShipmentBucket = {}));
//# sourceMappingURL=models.buckets.js.map